import { render, staticRenderFns } from "./tabCompanies.vue?vue&type=template&id=6c734587&scoped=true"
import script from "./tabCompanies.vue?vue&type=script&lang=js"
export * from "./tabCompanies.vue?vue&type=script&lang=js"
import style0 from "./tabCompanies.vue?vue&type=style&index=0&id=6c734587&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c734587",
  null
  
)

export default component.exports